// import { DatePicker, Upload, Modal, Row, Col, Button, TimePicker, Radio, Alert, Input, Select, Space, Switch, message, Card, Form } from 'antd';
// import React, { useEffect, useState } from 'react';
// import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
// import { DeleteOutlined, InboxOutlined, PlusOutlined, ExclamationCircleOutlined, CloseOutlined  } from '@ant-design/icons';
// import axios from 'axios';
// import dayjs from 'dayjs';
// import AdminModal from './AdminModal';
// const AdminClassTimeModal = (props) => {
//     const [count, setCount] = useState(0);

//     return (
//         <>
//             <AdminModal
//                 {...props}
//                 title={(<>
//                     <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 25, left: 45 }} >{props.title}</Col>
//                     <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 55, left: 25 }} >課程時間</Col>
//                 </>)}
//             >
//                 <Row gutter={[8, 8]} align={'middle'}>
//                     {/* <Col span={24}>
//                         <Row gutter={8}>
//                             <Col span={8}>課程開始時間</Col>
//                             <Col span={16}>
//                                 <TimePicker format={'HH:mm'}
//                                     // style={{ width: 200 }}
//                                     placeholder='必填'
//                                     value={props.editcard?.time_start && dayjs(props.editcard?.time_start, 'HH:mm')}
//                                     onChange={(time, timeString) =>
//                                         props.setEditCard(prev => {
//                                             return (
//                                                 {
//                                                     ...prev,
//                                                     time_start: timeString,
//                                                 }
//                                             )
//                                         })}></TimePicker>
//                             </Col>
//                         </Row>
//                     </Col>
//                     <Col span={8}>課程結束時間</Col>
//                     <Col span={16}>
//                         <TimePicker format={'HH:mm'}
//                             // style={{ width: 200 }}
//                             placeholder='必填'
//                             value={props.editcard?.time_end && dayjs(props.editcard?.time_end, 'HH:mm')}
//                             onChange={(time, timeString) =>
//                                 props.setEditCard(prev => {
//                                     return (
//                                         {
//                                             ...prev,
//                                             time_end: timeString,
//                                         }
//                                     )
//                                 })}></TimePicker>
//                     </Col> */}
//                     <Col span={6}>開始日期</Col>
//                     <Col span={18}>
//                         <DatePicker
//                             style={{ width: '100%' }}
//                             format={'YYYY-MM-DD'}
//                             value={props.editcard.time_start != null ? dayjs(props.editcard.time_start, 'YYYY-MM-DD') : ''}
//                             onChange={(value, dateString) => props.setEditCard(preState => {
//                                 return {
//                                     ...preState,
//                                     'time_start': dateString,
//                                 };
//                             })}
//                         />
//                     </Col>
//                     <Col span={6}>結束日期</Col>
//                     <Col span={18}>
//                         <DatePicker
//                             style={{ width: '100%' }}
//                             format={'YYYY-MM-DD'}
//                             value={props.editcard.time_end != null ? dayjs(props.editcard.time_end, 'YYYY-MM-DD') : ''}
//                             onChange={(value, dateString) => props.setEditCard(preState => {
//                                 return {
//                                     ...preState,
//                                     'time_end': dateString,
//                                 };
//                             })}
//                         />
//                     </Col>
//                     <Col span={24}>
//                     <Button type='primary' onClick={e => { setCount(count + 1); props.new_time_block.push({ key: count }) }}>新增授課階段</Button>
//                     </Col>
                   
                             
//                 </Row>
//             </AdminModal>
//         </>
//     );
// };
// export default AdminClassTimeModal;

import { DatePicker, Modal, Row, Col, Button, Card, Form, TimePicker, Input, Select } from 'antd';
import React, { useState, useEffect } from 'react';
import { ExclamationCircleOutlined, CloseOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import axios from 'axios';
import AdminModal from './AdminModal';

const { confirm } = Modal;

const AdminClassTimeModal = (props) => {
    const [count, setCount] = useState(0);
    const [form] = Form.useForm();
    const [lesson_category, set_lesson_category] = useState([]);
    const remove_new_time_block = (i) => {
        props.set_new_time_block(prev => prev.filter(filter_item => filter_item.key !== i));
    }

    const showDelete = (i) => {
        confirm({
            title: '確定要刪除嗎',
            icon: <ExclamationCircleOutlined />,
            okText: '確定',
            okType: 'primary',
            cancelText: '取消',
            onOk() {
                remove_new_time_block(i);
            },
            centered: true
        });
    }

    const handleDateChange = (key, field, value) => {
        props.set_new_time_block(prev => 
            prev.map(item => 
                item.key === key ? { ...item, [field]: value } : item
            )
        );
    }

    const addNewTimeBlock = () => {
        setCount(count + 1);
        props.set_new_time_block(prev => [...prev, { key: count }]);
    }

    console.log("Rendering AdminClassTimeModal with props: ", props);
    useEffect(() => {
        axios
            .get('/cramSchool/api/lesson_category')
            .then((response) => {
                set_lesson_category(response.data.data.map(map_item => {
                    return {
                        value: map_item.lesson_category_id,
                        label: map_item.name,
                    };
                }))

            })
    }, [])
    useEffect(() => {
        // console.log(props.editcard.lesson_class_data);
        if (props.editcard.lesson_category_data == undefined)
            props.setEditCard(prev => ({
                ...prev,
                lesson_category_data: [{
                    lesson_category_id: prev.lesson_id,
                    lesson_category_name: prev.label_name,
                }]
            })
            )
    }, [props.editcard])

    return (
        <>
            <AdminModal
                {...props}
                title={(
                    <>
                        <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 25, left: 45 }} >
                            {props.title}
                        </Col>
                        <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 55, left: 25 }} >
                            課程時間
                        </Col>
                    </>
                )}
            >
                <Row gutter={[8, 8]} align={'middle'}>
                    <Col span={24}>
                        <Button type='primary' onClick={addNewTimeBlock}>
                            新增授課階段
                        </Button>
                    </Col>
                    <Col span={24}>
                        <Form
                            form={form}
                            labelCol={{ span: 7 }}
                            wrapperCol={{ span: 18 }}
                            name="dynamic_form_complex"
                            autoComplete="off"
                            initialValues={{ items: [{}] }}
                        >
                            <Row gutter={[8, 8]}>
                                {props.new_time_block.map((item, i) => (
                                    <Col span={24} key={item.key}>
                                        <Card
                                            size="small"
                                            title={`第 ${i + 1} 授課階段`}
                                            headStyle={{ textAlign: 'center' }} // 设置标题居中样式
                                            extra={
                                                <CloseOutlined onClick={() => showDelete(item.key)} />
                                            }
                                        >
                                            {/* <Col span={6}>課程分類名稱</Col> */}
                                            <Form.Item label="課程分類名稱：" style={{ marginLeft: 0 }}>
                                            <Col span={18}>
                                                <Select
                                                    style={{ width: '133%'}}
                                                    labelInValue
                                                    value={props.editcard.lesson_category_name}
                                                    placeholder='請選擇課程分類'
                                                    name="title"
                                                    onChange={value => props.setEditCard(pre => {
                                                        return ({
                                                            ...pre,
                                                            lesson_category_name: value.label,
                                                            lesson_category_data: [{
                                                                lesson_category_id: value.value,
                                                                lesson_category_name: value.label,

                                                            }]
                                                        })
                                                    })}
                                                    options={lesson_category}>
                                                </Select>
                                            </Col>
                                            </Form.Item>
                                            <Form.Item label="開始日期">
                                                <DatePicker
                                                    style={{ width: '100%' }}
                                                    format={'YYYY-MM-DD'}
                                                    value={item.time_start ? dayjs(item.time_start, 'YYYY-MM-DD') : null}
                                                    onChange={(date, dateString) => handleDateChange(item.key, 'time_start', dateString)}
                                                />
                                            </Form.Item>
                                            <Form.Item label="結束日期">
                                                <DatePicker
                                                    style={{ width: '100%' }}
                                                    format={'YYYY-MM-DD'}
                                                    value={item.time_end ? dayjs(item.time_end, 'YYYY-MM-DD') : null}
                                                    onChange={(date, dateString) => handleDateChange(item.key, 'time_end', dateString)}
                                                />
                                            </Form.Item>
                                            <Form.Item label="請假時數限制：" style={{ marginLeft: 0 }}>
                                                <Row gutter={8} align="middle">
                                                    <Col span={18}>
                                                        <Input
                                                            style={{ width: '115%' }}
                                                            type='text'
                                                            value={item.leave_limit}
                                                            onChange={e =>
                                                                props.set_new_time_block(pre => {
                                                                    return (
                                                                        pre.map((value) => {
                                                                            if (value.key === item.key) {
                                                                                return {
                                                                                    ...value,
                                                                                    leave_limit: e.target.value
                                                                                };
                                                                            } else {
                                                                                return { ...value };
                                                                            }
                                                                        })
                                                                    );
                                                                })
                                                            }
                                                        />
                                                    </Col>
                                                    <Col span={6} style={{ textAlign: 'right', paddingRight: 5 }}> 
                                                        <span>小時</span>
                                                    </Col>
                                                </Row>
                                            </Form.Item>
                                            <br></br>
                                            <Card
                                            size="small"
                                            title={`新增時段`}
                                            headStyle={{ textAlign: 'center' }} // 设置标题居中样式
                                            extra={
                                                <CloseOutlined onClick={() => showDelete(item.key)} />
                                            }
                                            >
                                                <Card
                                                size="small"
                                                title={`上午`}
                                                >
                                                    <Form.Item label="開始時間">
                                                        <TimePicker
                                                            style={{ width: '100%' }}
                                                            format={'HH:mm'}
                                                            value={item.morning_start ? dayjs(item.morning_start, 'HH:mm') : null}
                                                            onChange={(time, timeString) => handleDateChange(item.key, 'morning_start', timeString)}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item label="結束時間">
                                                        <TimePicker
                                                            style={{ width: '100%' }}
                                                            format={'HH:mm'}
                                                            value={item.morning_end ? dayjs(item.morning_end, 'HH:mm') : null}
                                                            onChange={(time, timeString) => handleDateChange(item.key, 'morning_end', timeString)}
                                                        />
                                                    </Form.Item>
                                            </Card>        
                                            <Card
                                                size="small"
                                                title={`下午`}
                                                >
                                                    <Form.Item label="開始時間">
                                                        <TimePicker
                                                            style={{ width: '100%' }}
                                                            format={'HH:mm'}
                                                            value={item.afternoon_start ? dayjs(item.afternoon_start, 'HH:mm') : null}
                                                            onChange={(time, timeString) => handleDateChange(item.key, 'afternoon_start', timeString)}
                                                        />
                                                    </Form.Item>
                                                    <Form.Item label="結束時間">
                                                        <TimePicker
                                                            style={{ width: '100%' }}
                                                            format={'HH:mm'}
                                                            value={item.afternoon_end ? dayjs(item.afternoon_end, 'HH:mm') : null}
                                                            onChange={(time, timeString) => handleDateChange(item.key, 'afternoon_end', timeString)}
                                                        />
                                                    </Form.Item>
                                            </Card>        
                                            </Card>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </AdminModal>
        </>
    );
};

export default AdminClassTimeModal;
